
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/figma/[...slug]",
      function () {
        return require("private-next-pages/figma/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/figma/[...slug]"])
      });
    }
  